import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import {
	DefaultHeadersInterceptor,
	DefaultQueryParamsInterceptor,
	ServerErrorInterceptor,
	SessionErrorInterceptor,
	XCSRFInterceptor
} from './http-interceptors';

@NgModule({
	imports: [CommonModule, TranslateModule],
	providers: [
		{ provide: HTTP_INTERCEPTORS, useClass: XCSRFInterceptor, multi: true },
		{ provide: HTTP_INTERCEPTORS, useClass: DefaultQueryParamsInterceptor, multi: true },
		{ provide: HTTP_INTERCEPTORS, useClass: DefaultHeadersInterceptor, multi: true },
		{ provide: HTTP_INTERCEPTORS, useClass: ServerErrorInterceptor, multi: true },
		{ provide: HTTP_INTERCEPTORS, useClass: SessionErrorInterceptor, multi: true }
	]
})
export class AuthDataModule {}
